export enum DashboardActionTypes {
  UPDATE_FILTER = "@@DASHBOARD/UPDATE_FILTER",

  GET_PROTOCOLS = "@@DASHBOARD/GET_PROTOCOLS",
  GET_PROTOCOLS_SUCCESS = "@@DASHBOARD/GET_PROTOCOLS_SUCCESS",
  GET_PROTOCOLS_FAILURE = "@@DASHBOARD/GET_PROTOCOLS_FAILURE",

  SET_PROTOCOL_FAVORITE = "@@DASHBOARD/SET_PROTOCOL_FAVORITE",
}
